module.exports = __webpack_public_path__ + "img/404-image.2e587138.svg";